/**
 * @file   src\components\Common\InputGroup.js
 * @brief  This file is responsible for input group for location search component
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { InputGroup, FormControl, Button } from "react-bootstrap";
import React from "react";

const InputGroupControl = (props) => {
  const {
    id,
    inputGroupClass,
    ariaLabel,
    ariaDescribedBy,
    placeholder,
    errorMessage,
    errorMessageClass = "",
    iconClass,
    isIconEnable,
    iconId,
    btnVariant,
    value,
    onChange,
    inputRef,
    disabled,
    onClick,
    onBlur,
    onFocus,
    noStyles,
    noBorder,
  } = props;

  return (
    <>
      <InputGroup className={inputGroupClass} style={{ border: noBorder && '0px solid white' }}>
        <FormControl
          id={id}
          aria-label={ariaLabel}
          aria-describedby={ariaDescribedBy}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          ref={inputRef}
          disabled={disabled}
          onClick={onClick}
          onBlur={onBlur}
          onFocus={onFocus}
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            border: noBorder && '0px solid white',
          }}
        />

        {isIconEnable ? (
          <Button
            variant={btnVariant}
            className={`${iconClass}${noStyles ? " no-styles-btn" : ""}`}
            id={iconId}
            type="button"
            tabIndex={-1}
            aria-hidden="true"
            onClick={(e) => e.currentTarget.parentElement?.querySelector("input")?.focus()}
          ></Button>
        ) : (
          ""
        )}
      </InputGroup>
      {errorMessage && (
        <div className={`error-msg ${errorMessageClass}`.trim()}>
          {errorMessage && errorMessage !== "" && (
            <span className={`error-msg ${errorMessageClass}`.trim()}>
              {errorMessage}
            </span>
          )}
        </div>
      )}
    </>
  );
};

export default InputGroupControl;
